import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Calendar } from "lucide-react";

interface CalendlyEmbedProps {
  open: boolean;
  onClose: () => void;
}

export function CalendlyEmbed({ open, onClose }: CalendlyEmbedProps) {
  // TODO: Replace this placeholder with actual Calendly embed
  // Example Calendly embed code:
  // <div className="calendly-inline-widget" data-url="https://calendly.com/YOUR_LINK" style={{ minWidth: '320px', height: '700px' }} />
  // Add Calendly script: <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">
            Get Early Access
          </DialogTitle>
          <DialogDescription>Request early access to Taias</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center justify-center py-12 px-6 min-h-[400px] bg-muted/30 rounded-lg">
          <div className="mb-6 inline-flex p-4 rounded-full bg-gradient-to-br from-[#FF6A00] via-[#FF0099] to-[#6633FF] bg-opacity-10">
            <Calendar className="w-12 h-12 text-foreground" />
          </div>
          <h3 className="text-xl font-semibold mb-3 text-center">
            Calendly Integration Coming Soon
          </h3>
          <p className="text-muted-foreground text-center max-w-md leading-relaxed">
            We're setting up our early access program. In the meantime, please
            reach out to request access.
          </p>

          {/* Placeholder for actual Calendly widget */}
          <div className="mt-8 p-4 border-2 border-dashed border-muted-foreground/20 rounded-lg w-full">
            <p className="text-xs text-muted-foreground text-center font-mono">
              {`<!-- Calendly embed will appear here -->`}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
